import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UnsubscribeModalComponent } from './unsubscribe-modal';

export const UnsubscribeModalModule: string = ng
    .module('archiSmall.userSettings.unsubscribeModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('unsubscribeModalComponent', UnsubscribeModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/unsubscribe-modal/unsubscribe-modal.module.ts